import { useAppSelector } from "../../../hooks";

export default useToken;

function useToken(): string | undefined {
  const token = useAppSelector(({ token }) => token);
  return token ?? undefined;
}
